import Toastr from '../../../itrust_common/components/Toastr';

const parent = 'STORE_SETTING_';

const initialState = {
  masterPromotions: [],
  masterLoading: false,
  masterError: null,
  storePromotions: [],
  storeLoading: false,
  storeError: null,
  saving: false,
};

export default function promotionReducer(state = initialState, action) {
  const response =
    action.payload && (action.payload.data || action.payload.response);

  switch (action.type) {
    case `${parent}MASTER_PROMOTIONS_LOAD_PENDING`:
      return {
        ...state,
        masterLoading: true,
        masterError: null,
      };

    case `${parent}MASTER_PROMOTIONS_LOAD_REJECTED`:
      return {
        ...state,
        masterLoading: false,
        masterError: action.payload,
      };

    case `${parent}MASTER_PROMOTIONS_LOAD_FULFILLED`:
      return {
        ...state,
        masterLoading: false,
        masterPromotions: response?.promotions || response?.data || [],
        masterMeta: response?.meta || {},
      };

    case `${parent}STORE_PROMOTIONS_LOAD_PENDING`:
      return {
        ...state,
        storeLoading: true,
        storeError: null,
      };

    case `${parent}STORE_PROMOTIONS_LOAD_REJECTED`:
      return {
        ...state,
        storeLoading: false,
        storeError: action.payload,
      };

    case `${parent}STORE_PROMOTIONS_LOAD_FULFILLED`:
      return {
        ...state,
        storeLoading: false,
        storePromotions: response?.promotions || response?.data || [],
      };

    case `${parent}MASTER_PROMOTIONS_ADD_TO_STORE_PENDING`:
      return {
        ...state,
        saving: true,
      };

    case `${parent}MASTER_PROMOTIONS_ADD_TO_STORE_REJECTED`:
      Toastr.handleShow(
        false,
        response?.message || 'Failed to add promotions to store.',
        400
      );
      return {
        ...state,
        saving: false,
      };

    case `${parent}MASTER_PROMOTIONS_ADD_TO_STORE_FULFILLED`:
      Toastr.handleShow(
        true,
        response?.message || 'Promotions added successfully.',
        200
      );
      return {
        ...state,
        saving: false,
      };

    default:
      return state;
  }
}
